import request from "@/utils/request";
import baseUrl from "@/api/baseUrl";

export default class Role {
  /**
   * 查询本公司角色列表
   * @param {Object} params
   */
  static list(params = {}) {
    return request.get(`${baseUrl.vip}/role/list`, params);
  }

  static user(userId, config = {}) {
    return request.get(`${baseUrl.vip}/role/user/${userId}`, {}, config);
  }

  /**
   * 查询客户平台菜单权限
   */
  static menuList(params = {}, config = {}) {
    return request.get(`${baseUrl.vip}/role/menuList`, params, config);
  }

  /**
   * 新增本公司角色
   * @param {Object} data
   */
  static add(data = {}) {
    return request.post(`${baseUrl.vip}/role/add`, data);
  }

  /**
   * 修改本公司角色
   * @param {Object} data
   */
  static edit(data = {}) {
    return request.put(`${baseUrl.vip}/role/edit`, data);
  }



  /**
   * 角色授权
   * @param {Object} data
   */
  static grantMenu(data = {}) {
    return request.post(`${baseUrl.vip}/role/grantMenu`, data);
  }

  /**
   * 删除角色
   * @param {string|number} roleIds
   */
  static remove(roleIds) {
    return request.delete(`${baseUrl.vip}/role/${roleIds}`);
  }
}
